(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('PatientPictureSearch', PatientPictureSearch);

    PatientPictureSearch.$inject = ['$resource'];

    function PatientPictureSearch($resource) {
        var resourceUrl =  'api/_search/patient-pictures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
